import styled from "styled-components"

import { ButtonNew } from "components/form/ButtonNew"

export const WidgetsContainer = styled.div<{ sidebarOpen?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px 15px;
  margin-top: 2px;
  padding: 23px ${({ sidebarOpen }) => (sidebarOpen ? "24px" : "0")} 20px 0;

  max-height: calc(100dvh - 255px);
  overflow-y: auto;
`

export const Widget = styled.div`
  min-width: 350px;
  min-height: 244px;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  background: #f8fafc;
  padding: 17px 22px 15px;
  display: flex;
  flex-direction: column;
  flex: 1 1 calc(33.333% - 14px);
  align-self: stretch;

  @media (max-width: 1127px) {
    max-width: 100%;
  }

  @media (max-width: 770px) {
    max-width: 100%;
  }
`

export const WidgetTitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  color: #0f172a;
  margin: 0 0 16px 0;
  padding-bottom: 13px;
  border-bottom: 1px solid #e2e8f0;
`

export const UnseenCountBadge = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: -2px;
  padding: 0 4px;
  min-width: 18px;
  height: 18px;
  border-radius: 10px;
  background: rgb(215, 61, 61);
  font-size: 12px;
  margin-left: 8px;
  font-weight: 500;
  color: #fff;
  line-height: 1;
`

export const WidgetContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
`

export const ContentItem = styled.div`
  background: #ffffff;
  border-radius: 10px;
  padding: 8px 13px;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const IconWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  width: 20px;
  height: 20px;

  svg {
    width: 100%;
    height: 100%;
  }
`

export const ContentText = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #0f172a;
  flex: 1;
`

export const WidgetButton = styled.div`
  margin-top: auto;
  padding-top: 10px;
`

export const StyledWidgetButton = styled(ButtonNew)`
  height: 32px;
`

export const ChartContainer = styled.div`
  position: relative;
  width: 100%;
  height: 140px;
  margin: -6px 0 12px;
`

export const LegendContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-start;
  margin-top: auto;
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
`

export const LegendLabel = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #94a3b8;
`

export const StatusSectionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  flex: 1;
`

export const StatusSection = styled.div`
  background: #ffffff;
  border-radius: 10px;
  height: 56px;
  padding: 8px 13px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 1 calc(50% - 2.5px);
  min-width: 0;
`

export const StatusSectionTitle = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  text-transform: uppercase;
  margin-bottom: 4px;
`

export const StatusSectionContent = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #0f172a;
  display: flex;
  align-items: baseline;
  gap: 4px;
`

export const TemperatureDelta = styled.span`
  color: #64748b;
  font-size: 12px;
  font-weight: 400;
`

export const SystemStateText = styled.span<{ $color: string }>`
  color: ${({ $color }) => $color};
  font-size: 14px;
  font-weight: 400;
`

export const AlertItem = styled.div`
  background: #ffffff;
  border-radius: 10px;
  padding: 8px 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 56px;
`

export const AlertTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
  margin-bottom: 4px;
`

export const AlertDate = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #64748b;
`

export const AlertStatusWrapper = styled.div`
  flex-shrink: 0;
  margin-left: 12px;
  display: flex;
  align-items: center;
`

export const NoAlertsText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #64748b;
  text-align: center;
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`

export const PerformanceTestItem = styled.div`
  background: #ffffff;
  border-radius: 10px;
  padding: 8px 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 56px;
`

export const PerformanceTestTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
  margin-bottom: 4px;
`

export const PerformanceTestDate = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #64748b;
  text-align: left;
`

export const PerformanceTestStatusWrapper = styled.div`
  flex-shrink: 0;
  margin-left: 12px;
  display: flex;
  align-items: center;
`

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`

export const LegendColorBox = styled.div<{ $color: string }>`
  width: 12px;
  height: 12px;
  background: ${({ $color }) => $color};
  margin-right: 8px;
`
